import React from 'react';
import Alert from "@material-ui/lab/Alert";
import {useDispatch, useSelector} from "react-redux";
import {setSwBookStopoverState} from "../../../../../store/reducers/search-widget";
import {Grid, useMediaQuery, useTheme, Snackbar} from "@material-ui/core";

const BookStopoverAlertConnected = () => {

    const {breakpoints} = useTheme();
    const isMobile = useMediaQuery(breakpoints.down('sm'));
    const alertMessage = useSelector(state => state.sw.book.stopover.alertMessage);
    const dispatch = useDispatch();

    if (!alertMessage) return null;

    if (isMobile) {
        return (
            <Snackbar autoHideDuration={6000} anchorOrigin={{vertical: 'top', horizontal: 'right'}} onClose={() => dispatch(setSwBookStopoverState({alertMessage: null}))} open>
                <Alert onClose={() => dispatch(setSwBookStopoverState({alertMessage: null}))} {...alertMessage}/>
            </Snackbar>
        );
    }

    return (
        <Grid xs={12} item>
            <Alert onClose={() => dispatch(setSwBookStopoverState({alertMessage: null}))} {...alertMessage}/>
        </Grid>
    );
};

export default BookStopoverAlertConnected;